import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, spacing } from '@naf/theme';
import { GridCol, GridRow } from '@naf/grid';

export const HorizontalPadding = css`
  padding-left: ${spacing.space48};
  padding-right: ${spacing.space48};

  @media (max-width: ${breakpoints.m}) {
    padding-left: ${spacing.space24};
    padding-right: ${spacing.space24};
  }
`;

export const OtherTests = styled(GridRow)`
  margin-top: calc(${spacing.space64} - ${spacing.space32});
  ${HorizontalPadding};

  h2 {
    margin: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    margin-top: calc(${spacing.space56} - ${spacing.space24});
  }

  @media (max-width: ${breakpoints.s}) {
    margin-top: calc(${spacing.space40} - ${spacing.space24});
    padding: 0;
  }
`;

export const ShortCutCol = styled(GridCol)`
  display: flex;

  /* The Simba card sizes to its content, so let it fill the grid cell. */
  > * {
    flex: 1;
  }

  a {
    margin-bottom: 0;
  }
`;
